import React, { FC } from 'react'
import { Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const NotFound: FC<{}> = () => {
  const { t } = useTranslation()
  return (
    <>
      <Helmet>
        <title>Gateway [{t('notfound')}]</title>
      </Helmet>

      <Col className=' mx-auto contain'>
        <div className='content'>
          <h1 className='mb-5'>{t('pagenotfound')}</h1>
          <h1 className='output'>{t('pagenotfoundmessage')}</h1>
          <h1 className='output'>
            Click here to go <Link to='/'>Home</Link>
          </h1>
        </div>
      </Col>
    </>
  )
}
